<template>
    <svg id="printer" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 200 200" style="enable-background:new 0 0 200 200;" xml:space="preserve">
        <linearGradient id="SVGIDprinter_1_" gradientUnits="userSpaceOnUse" x1="334.0226" y1="545.9992" x2="40.4534" y2="-13.4837">
            <stop  offset="3.535350e-02" style="stop-color:#138BBD"/>
            <stop  offset="0.2257" style="stop-color:#169AC7"/>
            <stop  offset="0.5946" style="stop-color:#1FC3DF"/>
            <stop  offset="1" style="stop-color:#2AF6FF"/>
        </linearGradient>
        <path class="zc0 box_3" d="M0,0v200h200V0H0z M188.5,188.5h-177v-177h177V188.5z"/>
        <linearGradient id="SVGIDprinter_2_" gradientUnits="userSpaceOnUse" x1="138.76" y1="173.8686" x2="61.24" y2="26.1314">
            <stop  offset="3.535350e-02" style="stop-color:#138BBD"/>
            <stop  offset="0.2257" style="stop-color:#169AC7"/>
            <stop  offset="0.5946" style="stop-color:#1FC3DF"/>
            <stop  offset="1" style="stop-color:#2AF6FF"/>
        </linearGradient>
        <rect x="37.2" y="38.8" class="zc1" width="125.6" height="122.5"/>
        <g id="Layer_2">
            <g id="Layer_1-2">
                <path class="zc2" d="M80.4,40H39.4c-0.8,0-1.4,0.6-1.4,1.4V127c0,0.8,0.6,1.5,1.4,1.5h25.3c0.1-0.3,0.2-0.6,0.3-0.9 c2.1-5.5,2-11.9-0.2-19c-1.3-4.4-0.5-9.2,2.3-12.9c2.8-3.9,7.3-6.2,12.1-6.3h2.5V41.4c0-0.8-0.5-1.4-1.3-1.4 C80.5,40,80.4,40,80.4,40z M58.4,117.9c0,1.9-1.6,3.5-3.5,3.5h-9.7c-1.9,0-3.5-1.6-3.5-3.5v-2.2c0-1.9,1.6-3.5,3.5-3.5h9.7 c1.9,0,3.5,1.6,3.5,3.5V117.9z M70,85.9c-5.6,7.9-16.5,7.3-21.2-1.3c-6.5-11.8,6-26.5,11-37.6C64.2,59.4,79,73.1,70,85.9z"/>
                <path class="zc2" d="M90.3,132.6V161h45.5v-28.4H90.3z M127.3,155.3H98.8c-1.5-0.1-2.7-1.4-2.7-2.9c0.1-1.4,1.2-2.6,2.7-2.7h28.5 c1.5,0.1,2.7,1.4,2.7,2.9C129.9,154.1,128.8,155.2,127.3,155.3z M127.3,138.3c1.5,0,2.8,1.3,2.8,2.8c0,1.5-1.3,2.8-2.8,2.8H98.8 c-1.5,0-2.8-1.3-2.8-2.8c0-1.5,1.3-2.8,2.8-2.8H127.3z"/>
                <path class="zc2" d="M158.1,128.7c-2.5-6.8-2-14.2,0.1-21.1c2.3-7.5-4-15-11.4-15h-5.2v15.1c0,1.1-0.9,2-2,2l0,0H86.5 c-1.1,0-2-0.9-2-2V92.6h-5.2c-7.4,0-13.7,7.5-11.4,15c2.1,6.9,2.6,14.3,0.1,21.1c-2.4,6.5,2.7,14.1,9.3,15 c1.4,0.2,2.8,0.3,4.2,0.3c1.7,0,3-1.4,3-3v-12.1c0-1.1,0.9-2,2-2l0,0h53c1.1,0,2,0.9,2,2c0,0,0,0,0,0V141c0,1.7,1.4,3,3,3 c1.4,0,2.8-0.1,4.2-0.3C155.3,142.8,160.5,135.2,158.1,128.7z"/>
                <path class="zc2" d="M135.8,104V78.2c0-1.5-1.2-2.6-2.6-2.6l0,0H92.9c-1.5,0-2.6,1.2-2.6,2.6V104C90.3,104,135.8,104,135.8,104z"/>
                <path class="zc2" d="M158.1,128.7c-2.5-6.8-2-14.2,0.1-21.1c2.3-7.5-4-15-11.4-15h-5.2v15.1c0,1.1-0.9,2-2,2l0,0H86.5 c-1.1,0-2-0.9-2-2V92.6h-5.2c-7.4,0-13.7,7.5-11.4,15c2.1,6.9,2.6,14.3,0.1,21.1c-2.4,6.5,2.7,14.1,9.3,15 c1.4,0.2,2.8,0.3,4.2,0.3c1.7,0,3-1.4,3-3v-12.1c0-1.1,0.9-2,2-2l0,0h53c1.1,0,2,0.9,2,2c0,0,0,0,0,0V141c0,1.7,1.4,3,3,3 c1.4,0,2.8-0.1,4.2-0.3C155.3,142.8,160.5,135.2,158.1,128.7z"/>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "svg_printer"
    }
</script>

<style lang="scss">
    #printer{
        .zc0{fill:url(#SVGIDprinter_1_);}
        .zc1{display:none;fill:url(#SVGIDprinter_2_);}
        .zc2{fill:#FFFFFF;}
    }
    .box_3{animation:  color_box_3  15s infinite;}
    @keyframes color_box_3 {
        0%   {fill: url(#SVGIDDDDD_63_);}
        20%  {fill: url(#SVGIDDDDD_63_);}
        35%  {fill: url(#SVGIDDDDD_63_);}
        50%  {fill: #922cd3;}
        65%  {fill: url(#SVGIDDDDD_63_);}
        70%  {fill: url(#SVGIDDDDD_63_);}
        95%  {fill: url(#SVGIDDDDD_63_);}
        100% {fill: url(#SVGIDDDDD_63_);}
    }
</style>